export const tableColumns =  [
  {
    title: '姓名',
    value: 'name',
    header_align: 'center',
    align: 'center',
  },
  {
      title: '联系电话',
      value: 'mobile',
      header_align: 'center',
      align: 'center',
  },
  {
    title: '所属公司/高校',
    value: 'school_name',
    header_align: 'center',
    align: 'center',
  },
]